// Product types configuration - static list based on EventSchema
export const productTypes = [
  { label: 'CMP (Content Marketing Platform)', value: 'CMP' },
  { label: 'CMS (Content Management System)', value: 'CMS' },
  { label: 'COLLAB (Collaboration)', value: 'COLLAB' },
  { label: 'EXP (Experimentation)', value: 'EXP' },
  { label: 'ODP (Optimizely Data Platform)', value: 'ODP' },
];

export const eventNameOptions = [
  {
    label: 'Property Interaction',
    value: 'property-interaction',
    description:
      'When a property interaction occurs (e.g., task name changed, campaign due date changed)',
  },
  {
    label: 'Resource Interaction',
    value: 'resource-interaction',
    description: 'When a resource-level interaction occurs (e.g., task archived, campaign viewed)',
  },
  {
    label: 'Collection Interaction',
    value: 'collection-interaction',
    description:
      'When an item is added/removed from a collection (e.g., attachment added to campaign)',
  },
  {
    label: 'Collection Property Interaction',
    value: 'collection-property-interaction',
    description:
      'When a property inside a collection item changes (e.g., workflow step duration changed)',
  },
  {
    label: 'Tab Interaction',
    value: 'tab-interaction',
    description:
      'When a tab is interacted with inside a resource (e.g., campaign brief tab viewed)',
  },
];
